import HubspotService from "../service/hubspot.service";
import {
  AnalyticsCartViewedData,
  AnalyticsCheckoutStartedData,
  AnalyticsOrderCompletedData,
  AnalyticsSignInData,
  AnalyticsSignUpData,
  AnalyticsDesignUpdatedData,
  AnalyticsProductAddedOrRemovedData,
} from "../types/analytics.types";

/////////////////user////////////////

// When a user logs in, or right after signing up
export const identifyUser = (userId: string, userData: AnalyticsSignInData) => {
  window.analytics.identify(userId, userData);

  HubspotService.createOrUpdateContact(
    {
      firstname: userData.firstName,
      lastname: userData.lastName,
      email: userData.email,
      segment: userData.forWho,
    },
    userData.forWho
  );
};

// When a user creates an account
export const trackAccountCreated = (data: AnalyticsSignUpData) => {
  window.analytics.track("Account Created", data);

  HubspotService.createOrUpdateContact(
    {
      firstname: data.firstName,
      lastname: data.lastName,
      email: data.email,
      project_size: data.projectSize,
      segment: data.forWho,
      country: data.country === "CA" ? "Canada" : "United States",
      phone: data.contactPhone,
    },
    data.forWho
  );
};

export const trackSignIn = () => {
  window.analytics.track("Signed In");
  HubspotService.trackEvent("user_signed_in");
};

export const trackLogout = () => {
  window.analytics.track("Signed Out");
  window.analytics.reset();
};

///////////////dashboard////////////////

export const trackTeamCreated = () => {
  window.analytics.track("Team Created");
  HubspotService.trackEvent("team_created");
};

export const trackProjectCreated = () => {
  window.analytics.track("Project Created");
  HubspotService.trackEvent("project_created");
};

//productName: Hoodie, Hoodie Zip, etc. from Specs, not the name given by the user
export const trackDesignCreated = (productName: string) => {
  window.analytics.track("Design Created", {
    product: productName,
  });

  HubspotService.trackEvent("design_created", {
    product: productName,
  });
};

export const trackDesignUpdated = (data: AnalyticsDesignUpdatedData) => {
  window.analytics.track("Design Updated", data);
};

///////////////cart////////////////

export const trackProductAdded = (data: AnalyticsProductAddedOrRemovedData) => {
  window.analytics.track("Product Added to Cart", data);

  HubspotService.trackEvent("product_added_to_cart", {
    product: data.name,
  });
};

export const trackProductRemoved = (
  data: AnalyticsProductAddedOrRemovedData
) => {
  window.analytics.track("Product Removed from Cart", data);
};

export const trackCartViewed = (data: AnalyticsCartViewedData) => {
  window.analytics.track("Cart Viewed", data);
  HubspotService.trackEvent("cart_viewed");
};

export const trackCheckoutStarted = (data: AnalyticsCheckoutStartedData) => {
  window.analytics.track("Checkout Started", data);

  HubspotService.trackEvent("checkout_started", {
    value: data.value.toString(),
    currency: data.currency,
  });
};

export const trackOrderCompleted = (data: AnalyticsOrderCompletedData) => {
  window.analytics.track("Order Completed", data);

  HubspotService.trackEvent("order_completed", {
    value: data.total.toString(),
    currency: data.currency,
  });
};
